import { connect } from 'react-redux';

import ButtonPreview from '../../../components/Editor/ButtonPreview';
import { StoreState } from '../../../reducers';
import { getClientAndResourceIds } from '../utils/helpers';
import Utils from '../../../utils';
import ApiUtils from '../../../utils/api';

const mapStateToProps = (state: StoreState) => {
	const {
		editor: {
			label: { label },
			preprodPublication: { urlWithPin },
			paths: { accessibleUrl },
			isAccessibleVersion,
		},
		driveList: { driveItems },
		galleryInfos: {
			template: { sharedNetworks },
		},
	} = state;
	const { clientId, tempGId, originalGId } = getClientAndResourceIds();
	const driveItem = driveItems[tempGId] || driveItems[originalGId];
	const accessibleUrlWithToken = accessibleUrl ? accessibleUrl + `${Utils.getUrlSeparator(accessibleUrl)}token=${ApiUtils.token}` : '';

	return {
		url: isAccessibleVersion ? accessibleUrlWithToken : urlWithPin,
		clientId,
		tempGId,
		label,
		driveItem,
		isAccessibleVersion,
		isShareByCopyEnabled: Utils.isEmbedMode() ||
			Utils.isShareOnlyViaCopyEnabled(sharedNetworks) ||
			Utils.isMultipleShareEnabled(sharedNetworks),
		isShareByEmailEnabled: !Utils.isEmbedMode() && !isAccessibleVersion && (
			Utils.isShareOnlyViaUprezEnabled(sharedNetworks) ||
			Utils.isMultipleShareEnabled(sharedNetworks)
		),
	};
};

export default connect(mapStateToProps)(ButtonPreview);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/ButtonPreview/index.tsx